import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Pagination, Stack, Switch } from "@mui/material";
import { Addstocks } from "../addstocks";
import moment from "moment";
import { EditStock } from "../adminStocksEdit";
import { Loader } from "../loader";
import api from "../../../api";

// Import Lucide icons
import {
  Plus,
  Image,
  Video,
  FileText,
  Edit2,
  Trash2,
  Search,
  Filter,
  Calendar,
  User,
  Download,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { AddBanner } from "./addBanner";
import { useAlert } from "react-alert";

export function BannerAdmin({ match }) {
  const alert = useAlert();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfPost, setnoOfPost] = useState(0);
  const [loader, setLoader] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [selectedData, setSelectedData] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = (item) => {
    setSelectedData(item);
    setShowEdit(true);
  };

  const getPosts = async () => {
    try {
      let payload = { page: page };
      setLoader(true);
      const postData = await api.bannerGet(payload);
      console.log(postData);

      setData(postData.banner);
      setnoOfPost(postData.count);
      setLimit(postData.limit);
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  const deletePost = async (id) => {
    try {
      let payload = { id: id };
      setLoader(true);
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this item?"
      );
      if (isConfirmed) {
        await api.bannerDelete(payload);
        getPosts();
      }
      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  useEffect(() => {
    getPosts();
  }, [page]);

  const toggleBanner = async (e, bId) => {
    try {
      setLoader(true);
      const isConfirmed = window.confirm(
        `Are you sure you want to ${
          e.target.checked ? "active" : "in-active"
        } this banner?`
      );
      let payload = {
        id: bId,
        isActive: e.target.checked,
      };
      if (isConfirmed) {
        const userData = await api.bannerEdit(payload);
        console.log(userData);
        if (userData?.success) {
          console.log("updated");
          alert.show(userData?.message || "Data updated");
          getPosts();
        }
      }

      setLoader(false);
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  return (
    <div className="crypto-trades-admin">
      {/* Header Section */}
      <div className="crypto-trades-header">
        <div className="content-of-header mb-0">
          <div className="title-section">
            <h1 className="crypto-trades-title">Mobile Home Banner</h1>
          </div>
          <button className="crypto-trades-add-btn" onClick={handleShow}>
            <Plus size={18} />
            Add Banner
          </button>
        </div>
      </div>

      {/* Main Content */}
      <div className="dashboard-content">
        <div className="table-section">
          <div className="section-header">
            <h3>All Banners</h3>
            <div className="results-info">
              {data.length} {data.length === 1 ? "item" : "items"} found
            </div>
          </div>

          <Table
            data={data}
            setPage={setPage}
            page={page}
            noOfPost={noOfPost}
            limit={limit}
            deletePost={deletePost}
            handleShowEdit={handleShowEdit}
            handleShow={handleShow}
            toggleBanner={toggleBanner}
          />
        </div>
      </div>

      {/* Modals */}
      <Modal
        show={show}
        size="lg"
        onHide={handleClose}
        centered
        className="modern-modal"
      >
        <Modal.Body>
          <div className="modal-content-wrapper">
            <div className="modal-header">
              <h3>Add New Banner</h3>
              <button className="modal-close-btn" onClick={handleClose}>
                ×
              </button>
            </div>
            <AddBanner getPosts={getPosts} setShow={setShow} />
          </div>
        </Modal.Body>
      </Modal>
      {/* 
      <Modal show={showEdit} size="lg" onHide={handleCloseEdit} centered className="modern-modal">
        <Modal.Body>
          <div className="modal-content-wrapper">
            <div className="modal-header">
              <h3>Edit Banner</h3>
              <button className="modal-close-btn" onClick={handleCloseEdit}>
                ×
              </button>
            </div>
            <EditStock
              getData={getPosts}
              setShow={setShowEdit}
              editData={selectedData}
            />
          </div>
        </Modal.Body>
      </Modal> */}

      {loader && <Loader />}
    </div>
  );
}

const Table = ({
  data,
  page,
  setPage,
  noOfPost,
  limit,
  deletePost,
  handleShowEdit,
  handleShow,
  toggleBanner,
}) => {
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    return moment(date).format("MMM D, YYYY • h:mm A");
  };

  if (data.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">📊</div>
        <h3>No Banner Found</h3>
        <p>Start by adding your banner</p>
        <button className="empty-action-btn" onClick={() => handleShow()}>
          <Plus size={16} />
          Add First Banner
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="table-responsive-container">
        <table className="modern-table">
          <thead>
            <tr>
              <th>IMAGE</th>
              <th>ACTIVE</th>
              <th>CREATED AT</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, key) => (
              <tr key={key}>
                <td className="image-cell">
                  {item.imageTitle ? (
                    <div className="image-preview">
                      {item.imageTitle
                        .split(",")
                        .slice(0, 1)
                        .map((val, idx) => (
                          <div className="image-thumb" key={idx}>
                            <img
                              src={`${process.env.REACT_APP_S3URL}/img_${val}.${
                                item.imageFormat.split(",")[idx]
                              }`}
                              alt={`Stock ${key + 1}`}
                            />
                            {item.imageTitle.split(",").length > 1 && (
                              <span className="image-count">
                                +{item.imageTitle.split(",").length - 1}
                              </span>
                            )}
                          </div>
                        ))}
                    </div>
                  ) : (
                    <span className="no-content">-</span>
                  )}
                </td>
                <td>
                  <div className="mr-5 w-40">
                    <Switch
                      checked={item?.isActive}
                      onChange={(e) => toggleBanner(e, item?._id)}
                      slotProps={{ input: { "aria-label": "controlled" } }}
                    />
                  </div>
                </td>

                <td className="date-cell">
                  <div className="date-info">
                    <Calendar size={14} />
                    <span>{formatDate(item?.createdAt)}</span>
                  </div>
                </td>
                <td className="actions-cell">
                  <div className="action-buttons">
                    {/* <button
                      className="action-btn edit-btn"
                      onClick={() => handleShowEdit(item)}
                    >
                      <Edit2 size={16} />
                    </button> */}
                    <button
                      className="action-btn delete-btn"
                      onClick={() => deletePost(item?._id)}
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {data.length > 0 && (
        <div className="pagination-container">
          <div className="pagination-info">
            Showing {Math.min((page - 1) * limit + 1, noOfPost)} to{" "}
            {Math.min(page * limit, noOfPost)} of {noOfPost} entries
          </div>
          <Stack spacing={2}>
            <Pagination
              count={Math.ceil(noOfPost / limit)}
              page={page}
              onChange={handleChange}
              shape="rounded"
              variant="outlined"
              size="medium"
              className="custom-pagination"
            />
          </Stack>
        </div>
      )}
    </>
  );
};
